import { pxToRem } from '@withjoy/joykit/theme';

export const footerButtonOverrides = {
  Root: {
    props: {
      fontSize: pxToRem(15),
      fontWeight: 400,
      padding: 0,
      color: 'mono6',
      _hover: {
        color: 'mono10'
      },
      _active: {
        color: 'mono14'
      }
    }
  }
};
